import openModal from '@PROJECT_ROOT/assets/shared/js/modalBox';

const recommending = {
    invitationForm: null,
    invitationSubmit: null,
    recommendingNotice: null,
    partnerForm: null,
    init: (config) => {
        const self = recommending;
        // očekuje se u config varijabli
        self.invitationFormId = config.invitationForm;
        self.partnerDefinition = config.partnerDefinition;
        self.recommendingNotice = $(self.invitationFormId).data('recommending-notice');
        self.popupId = $(self.partnerDefinition).data('login-popup');
        self.partnerLoginDiv = $(self.partnerDefinition).data('partner-login');
        self.partnerLoginFormId = $(self.partnerDefinition).data('partner-login-form');
        self.registrationToLogin = $(self.partnerDefinition).data('registration-to-login');
        self.partnerRegistrationDiv = $(self.partnerDefinition).data('partner-registration');
        self.partnerRegistrationFormId = $(self.partnerDefinition).data('partner-registration-form');
        self.loginToRegistration = $(self.partnerDefinition).data('login-to-registration');
        self.loginLinkId = $(self.partnerDefinition).data('login-link');
        self.registerLinkId = $(self.partnerDefinition).data('register-link');

        // Ucitavanje login forme
        if ($(self.loginLinkId).length) {
            $(self.loginLinkId).on('click', function getLoginForm() {
                const ajaxUrl = $(this).data('ajax-url');
                $.get(ajaxUrl, { type: 'login' })
                    .then((response) => {
                        if (response.status === 'success_get_forms') {
                            const recommendingForms = response.formsHtml;
                            openModal(recommendingForms, { overlayCss: ['recommendingModal'] });
                            $(self.partnerLoginDiv).removeClass('hide');
                            self.recommendingPartnerLogin();
                        }
                    });
            });
        }

        // Ucitavanje registracijske forme
        if ($(self.registerLinkId).length) {
            $(self.registerLinkId).on('click', function getRegisterForm(event) {
                const ajaxUrl = $(this).data('ajax-url');
                event.preventDefault();
                $.get(ajaxUrl, { type: 'registration' })
                    .then((response) => {
                        if (response.status === 'success_get_forms') {
                            const recommendingForms = response.formsHtml;
                            openModal(recommendingForms, { overlayCss: ['recommendingModal'] });
                            $(self.partnerRegistrationDiv).removeClass('hide');
                            self.recommendingPartnerRegistration();
                        }
                    });
            });
        }
        // Invitation
        if ($(self.invitationFormId).length) {
            $(self.invitationFormId).on('submit', function invitation(event) {
                self.sendInvitation(this, event);
            });
        }
    },
    sendInvitation(context, event) {
        const self = this;
        const ajaxUrl = $(context).attr('action');
        const postData = $(context).serialize();
        const trackerLabel = $(context).find('button').data('tracking-label');
        event.preventDefault();
        $.post(ajaxUrl, postData)
            .then((response) => {
                if (response.status === 'ok') {
                    $(self.invitationFormId).parent().parent().html(response.data.recommendingInvitationHtml);
                    setTimeout(() => {
                        $(self.recommendingNotice).fadeOut();
                    }, 5000);
                    /* eslint-disable-next-line no-undef */
                    ga('send', 'event', 'Recommending', 'Success', trackerLabel);
                } else if (response.status === 'error') {
                    $(self.invitationFormId).parent().parent().html(response.data.recommendingInvitationHtml);
                    /* eslint-disable-next-line no-undef */
                    ga('send', 'event', 'Recommending', 'Error', trackerLabel);
                }
                $(self.invitationFormId).off('submit');
                if ($(self.invitationFormId).length) {
                    $(self.invitationFormId).on('submit', function invitation(e) {
                        self.sendInvitation(this, e);
                    });
                }
            });
    },
    recommendingPartnerLogin() {
        const self = this;
        if ($(self.partnerLoginFormId).length) {
            $(document).off('submit', self.partnerLoginFormId);
            $(document).on('submit', self.partnerLoginFormId, function loginUser(event) {
                const ajaxUrl = $(this).attr('action');
                const postData = $(this).serialize();

                event.preventDefault();

                $.post(ajaxUrl, postData)
                    .then((response) => {
                        if (response.status === 'ok') {
                            $(self.popupId).parent().find('.closeModal').click();
                            window.location.reload();
                        } else {
                            $(self.partnerLoginDiv).html(response.loginFormHtml);
                        }
                    })
                    .fail(() => false);
            });
            $(document).off('click', self.loginToRegistration);
            $(document).on('click', self.loginToRegistration, (event) => {
                event.preventDefault();
                $(self.partnerLoginDiv).addClass('hide');
                $(self.partnerRegistrationDiv).removeClass('hide');
                self.recommendingPartnerRegistration();
            });
        }
    },
    recommendingPartnerRegistration() {
        const self = this;
        if ($(self.partnerRegistrationFormId).length) {
            $(document).off('submit', self.partnerRegistrationFormId);
            $(document).on('submit', self.partnerRegistrationFormId, function registerUser(event) {
                const ajaxUrl = $(this).attr('action');
                const postData = $(this).serialize();

                event.preventDefault();

                $.post(ajaxUrl, postData)
                    .then((response) => {
                        if (response.status === 'success') {
                            $(self.popupId).parent().find('.closeModal').click();
                            window.location.reload();
                        } else {
                            $(self.partnerRegistrationDiv).html(response.partnerRegistrationHtml);
                        }
                    })
                    .fail(() => false);
            });
            $(document).off('click', self.registrationToLogin);
            $(document).on('click', self.registrationToLogin, (event) => {
                event.preventDefault();
                $(self.partnerRegistrationDiv).addClass('hide');
                $(self.partnerLoginDiv).removeClass('hide');
                self.recommendingPartnerLogin();
            });
        }
    },
};

export default recommending;
